// extracted by mini-css-extract-plugin
export default {"innerWrapper":"innerWrapper-CFoW1","tag":"tag-tcU_y"};